import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { createPortLoading } from '../services/portLoadingService';
import { queryKeys } from '../constants/queryKeys';

/**
 * useCreatePortLoading — POST /portloading
 * On success, invalidates the portLoading query so the Origin dropdown refreshes.
 */
export const useCreatePortLoading = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => createPortLoading(data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.portLoading.all });
      toast.success('Origin added successfully!');
    },

    onError: (error) => {
      const message = error?.response?.data?.message || 'Failed to add origin. Please try again.';
      toast.error(message);
    },
  });
};
